import { Typography, Stack, Box, useTheme } from "@mui/material";

interface SectionTitleProps {
  text: string | React.ReactNode;
  subtitle?: string;
}

export function SectionTitle({ text, subtitle }: SectionTitleProps) {
  const theme = useTheme();
  return (
    <Stack spacing={subtitle ? 2 : 1.5} alignItems="flex-start" mb={3}>
      <Typography
        variant="h5"
        fontWeight={900}
        color="primary.main"
        sx={{
          textShadow: '0 2px 8px rgba(80, 80, 80, 0.10)',
          letterSpacing: 0.5,
        }}
      >
        {text}
      </Typography>
      <Box
        sx={{
          width: 60,
          height: 6,
          borderRadius: 3,
          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          boxShadow: '0 2px 8px rgba(80, 80, 80, 0.10)',
          mb: subtitle ? 0.5 : 0,
        }}
      />
      {subtitle && (
        <Typography
          variant="subtitle1"
          color="neutral500.main"
          fontWeight={400}
          sx={{ mt: 0.5, letterSpacing: 0.2 }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
} 